<div class="conformation-container">
  <mat-icon class="success-icon" [svgIcon]="'ak-success'"></mat-icon>
  <p>{{ 'confirmation' | translate }}</p>
</div>
